import { Button } from "@/components/button";
import styled from "@emotion/styled";

export const DeleteKeywordButton = styled(Button)`
    position: absolute;
    display: flex;
    width: 40px;
    height: 100%;
    padding: 0;
    border: none;
    box-sizing: border-box;
    z-index: 9999;
    top: 0;
    right: 0;
    background: none;
    border-radius: 0;

    &::before {
        content: "";
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        display: block;
        width: 1px !important;
        height: 24px !important;
    }
`;
